export const en = {
  'app.components.dashboard.title': 'Dashboard',
  'app.components.order-selector.title': 'Show open orders:',
  'app.components.order-selector.today': 'Today',
  'app.components.order-selector.tomorrow': 'Tomorrow',
  'app.components.order-selector.later': 'Later',
  'app.components.hamburger-menu.title': 'Active Orders',
  'app.components.hamburger-menu.aria-label': 'Menu',
  'app.components.search-button.aria-label': 'Search button',
  'app.components.product-item-controls.accept': 'Accept',
  'app.components.product-control-switcher.switch-product-control': 'Switch product control',
  'app.components.simple-cycle.labels': `{labels, number} {labels, plural,
    one {Label}
    other {Labels}
  }`,
  'app.components.simple-cycle.orders': `{orders, number} {orders, plural,
    one {Open order}
    other {Open orders}
  }`,
  'app.components.simple-cycle.today': '{date}, Today',
  'app.components.cycle-header.today': '{date}, Today',
  'app.components.cycle-header.count': `{ count, number } {count, plural,
    one { order }
    other { orders}
  }`,
  'app.components.cycle-header.label-items': 'Labeled items',
  'app.components.modal.close-button-aria-label': 'Close modal',
  'app.components.product-item-controls.print': 'Print',
  'app.components.cycle-order.consolidate': 'Consolidate',
  'app.components.order-consolidate-modal.consolidate': 'Consolidate',
  'app.components.order-consolidate-modal.button': 'Select the items you want to consolidate',
  'app.components.order-consolidate-modal.consolidate-items': `Consolidate { amount, number } { amount, plural,
    one { item }
    other { items }
  }`,
  'app.components.product-decline-form.title': 'Tell us the reason',
  'app.components.product-decline-form.form-button': 'Ok',
  'app.components.product-quantity-selector.question': 'How many can you deliver?',
  'app.components.product-quantity-selector.increase': 'Increase product quantity',
  'app.components.product-quantity-selector.decrease': 'Decrease product quantity',
  'app.components.product-quantity-selector.product-quantity': 'Product quantity',
  'app.components.change-order-status-button.move-ready-button': 'Move to ready',
  'app.components.change-order-status-button.remove-button': 'Remove from pallet',
  'app.components.change-order-status-button.to-in-progress-button': 'Move to in-progress',
  'app.components.change-order-status-button.reason': 'Moved to In-Progress',
  'app.components.change-order-status-button.awaiting-final-po': 'Awaiting PO number',
  'app.components.change-order-status-button.awaiting-final-po-tooltip': 'Will unlock when purchase order number is received',
  'app.components.change-order-status-button.final-po-received-toast': 'Order #{orderId} — labels can now be printed and the order moved to Ready.',
  'app.components.product-item-controls.print-awaiting-final-po-tooltip': 'The label includes the final purchase order — cannot print until it is received.',
  'app.components.time-status.ends': 'Ends',
  'app.components.time-status.cycle-ended': 'Cycle ended',
  'app.components.product-modal.unpack': 'Unpack',
  'app.components.product-modal.print-label': 'Print',
  'app.components.product-modal.re-print-label': 'Re-print label',
  'app.components.product-modal.unpack-to-detach': 'Unpack to detach from order',
  'app.components.product-decline-button.decline': 'Decline',
  'app.components.product-decline-button.tooltip': 'In order to Decline, you need to Unpack first',
  'app.components.cycle-modal.ok': 'OK',
  'app.components.got-it.text': 'Got it',
  'app.components.orders-columns.incoming': 'Incoming',
  'app.components.orders-columns.in-progress': 'In progress',
  'app.components.orders-columns.ready': 'Ready',
  'app.components.app-drawer.settings': 'Settings',
  'app.components.app-drawer.language': 'Language',
  'app.components.app-drawer.printer': 'Printer',
  'app.components.app-drawer.label-format': 'Label format',
  'app.components.app-drawer.label-format.zpl': 'Label printer (4x4)',
  'app.components.app-drawer.label-format.pdf': 'PDF document',
  'app.components.app-drawer.label-size': 'Label size',
  'app.components.app-drawer.printer-connection': 'Connection',
  'app.components.app-drawer.printer-connection.auto': 'Automatic',
  'app.components.app-drawer.printer-connection.bluetooth': 'Bluetooth',
  'app.components.app-drawer.printer-connection.usb': 'USB cable',
  'app.components.app-drawer.printer-device': 'Printer',
  'app.components.app-drawer.printer-device.automatic': 'First available',
  'app.components.app-drawer.printer.dialog-title': 'Choose printer',
  'app.components.app-drawer.printer.bluetooth': 'Bluetooth',
  'app.components.app-drawer.printer.allow-bluetooth': 'Allow Bluetooth access',
  'app.components.app-drawer.printer.no-paired': 'No paired printers. Pair one in the Android Bluetooth settings first.',
  'app.components.app-drawer.printer.pair-new': 'Pair a new printer',
  'app.components.app-drawer.printer.usb': 'USB cable',
  'app.components.app-drawer.printer.no-usb': 'No printer detected on the cable.',
  'app.components.app-drawer.printer.usb-ready': 'Ready ({deviceKey})',
  'app.components.app-drawer.printer.usb-unsupported': 'Not usable as a printer ({deviceKey}, class {interfaceClasses})',
  'app.components.app-drawer.printer.usb-tap-to-allow': 'Tap to allow access',
  'app.components.app-drawer.printer.identify': 'Detect printer model and resolution',
  'app.components.app-drawer.printer.identifying': 'Identifying…',
  'app.components.app-drawer.printer.refresh': 'Refresh',
  'app.components.app-drawer.printer.done': 'Done',
  'app.components.app-drawer.app-info': 'App Information',
  'app.components.app-drawer.version': 'Version',
  'app.components.app-drawer.account': 'Account',
  'app.components.app-drawer.logout': 'Logout',
  'app.toasts.printer-not-disconnected': 'Printer is not disconnected',
  'app.toasts.text-not-printing': 'Text is not printing',
  'app.toasts.printer-not-connected': 'Printer is not connected',
  'app.toasts.bluetooth-disabled': 'Please enable bluetooth',
  'app.toasts.printer-status-unknown': 'Unknown printer status',
  'app.toasts.pdf-label-downloaded': 'PDF label downloaded. Please open and print the downloaded file.',
  'app.toasts.printer-permission-denied': 'Permission to use the printer was denied. Please allow it and try again.',
  'app.toasts.printer-device-not-found': 'The selected printer was not found. Check that it is switched on and connected, or choose another one in the menu.',
  'app.toasts.native-pdf-print-unavailable': 'This app version cannot print PDF labels. Please update the app, or switch the label format back to the label printer in the menu.',
  'app.toasts.bluetooth-printer-unavailable': 'No Bluetooth label printer is available here. Please switch the label format to PDF in the menu.',
  'app.toasts.print-error': 'Print Error: {error}',
  'app.toasts.print-error-unknown': 'Unknown error',
  'app.components.notification-gate.title': 'Enable notifications',
  'app.components.notification-gate.body-prompt': 'Deliverider uses notifications to alert you about new orders. Notifications are required to log in.',
  'app.components.notification-gate.body-denied': 'Notifications are turned off, and they are required to log in. Please turn them on to continue:',
  'app.components.notification-gate.steps-ios': '1. Tap "Open Settings" below\n2. Tap "Notifications"\n3. Turn on "Allow Notifications"\n4. Return to this screen',
  'app.components.notification-gate.steps-android': '1. Tap "Open Settings" below\n2. Turn on "Allow notifications"\n3. Return to this screen',
  'app.components.notification-gate.enable': 'Enable notifications',
  'app.components.notification-gate.open-settings': 'Open Settings',
  'app.components.notification-gate.cancel': 'Cancel',
  'app.notifications.order_created': 'New order #{order_id}',
  'app.notifications.order_canceled': 'Order #{order_id} was canceled',
  'app.notifications.item_canceled': 'An item in order #{order_id} was canceled',
  'app.notifications.order_updated': 'Order #{order_id} was updated',
  'app.notifications.order_status_incomplete': 'Order #{order_id} is incomplete',
  'app.notifications.order_not_delivered': 'Order #{order_id} was not delivered',
  'app.notifications.order_acceptance_overdue': '⏰ Your acceptance time is up for order #{order_id}. Tap to accept and start preparing it for pickup before it is reassigned.',
}
